import styled from 'styled-components';

export const ModalPopup = styled.div`
display: block;
width: 100%;
height: 100%;
flex-direction: column;
justify-content: center;	
padding: 1.5rem 1.2rem;
max-height: 344px;
overflow-y: auto;
box-sizing: border-box;
`;

export const ModalcontentInfo = styled.div`
	margin-bottom: 28px;
	max-height: 240px;
	color: var(--textTitleColor);
	font-size: 1em;
	text-align:center;
`;
export const Modalbutton = styled.button`
background: var(--primary);
appearance: none;
border: 1px solid var(--primary);
padding: 10px 22px;
border-radius: 3px;
color: var(--btnLabel);
font-weight: 600;
font-size: 1rem;
cursor: pointer;
text-align: center;
display: flex;
justify-content: center;

&:hover,&:focus{
	background: var(--primary);
}
`;

export const ModalbuttonNo = styled.button`
background: var(--btnBgNo);
appearance: none;
border: 1px solid var(--btnBgNo);
padding: 10px 22px;
border-radius: 3px;
color: var(--textTitleColor);
font-weight: 600;
font-size: 1rem;
cursor: pointer;
text-align: center;
display: flex;
max-width: 120px;
justify-content:center;
margin: 0;

&:hover, &:focus{
	background: var(--modalBtnHoverBgColor);
}
`;
export const ModalbuttonWrap = styled.div`
		display: flex;
		flex-direction: column;
    justify-content: center;
		align-items: center;
		margin: 10px 0px;
		gap: 10px;
		flex-direction: row-reverse;
`;

export const ModaliconInfo = styled.div`
	margin-bottom: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const DialogTextArea = styled.textarea`
	width: 100%;
	height: calc(2.4rem * 2);
	border: 1px solid var(--borderColor);
	border-radius: 4px;
	padding: 10px;
	box-sizing: border-box;
	font-size: 14px;
	resize: none;
	overflow-y: auto;
	rows: 3;
	&:focus {
		outline: none;
		border: 1px solid var(--primary);
	}
	&::placeholder {
		color: #bdbdbd;
	}
`;

export const DialogContentInfo = styled.div`
	margin-bottom: 6px;
	color: rgb(74, 82, 90);
	font-weight: 500;
	font-size: 1rem;
	white-space: nowrap;
`;
export const ModalORText= styled.div`
		font-size: .95rem;
		text-align: center;
		 display: flex;
		 flex: 1;
		 justify-content: center;
		 
		 width: 100%;
		 margin-block: 8px;
		 position: relative;

		 &:before{
		 content: '';
		 position: absolute;
		 top: 50%;
		 width: 90%;
			transform: translateY(-50%);
			left: 50%;
			transform: translate(-50%, -50%);
		 border-bottom: 1px solid rgb(189 189 189 / 24%);
		 }

		 span{
			font-size: .95rem;
			line-height: 1.4;
			background: var(--modalBgColor);
			padding: .45rem 1rem;
			positionL relative;
			z-index: 2;
		 }
		
`;